/**
 * Extrai a mensagem de negócio devolvida pela API.
 *
 * O back-end não tem um formato único de erro: o easymarine-core devolve
 * `{ statusCode, message }`, alguns módulos usam o formato estilo Spring
 * (`{ status, error, message }`) e o gateway tem shape próprio. Esta função tenta os
 * formatos conhecidos, na ordem, e só cai no texto padrão quando nenhum traz mensagem.
 *
 * Sem isso, a tela mostra "ocorreu um erro" mesmo quando o servidor explicou exatamente
 * o que estava errado — por exemplo, que a data já está reservada.
 */
export function extractApiMessage(error: any, fallback: string): string {
  const body = error?.error;

  if (typeof body === 'string' && body.trim()) {
    // Alguns endpoints devolvem a mensagem crua, sem envelope JSON.
    return isProbablyJson(body) ? parseJsonMessage(body, fallback) : body;
  }

  const message = body?.message || body?.error || body?.detail;
  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  return fallback;
}

function isProbablyJson(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.startsWith('{') || trimmed.startsWith('[');
}

function parseJsonMessage(value: string, fallback: string): string {
  try {
    const parsed = JSON.parse(value);
    return parsed?.message || parsed?.error || fallback;
  } catch {
    return fallback;
  }
}
